import { createContext } from "react";
import { UseMutationResult, useQuery } from "@tanstack/react-query";

export type Theme = "light" | "dark";

export type ThemeContextType = {
  useQueryTheme: () => ReturnType<typeof useQuery>;
  setTheme: UseMutationResult<void, Error, Theme, unknown>;
  refreshTenantStylesheet: () => Promise<void>;
};

export const ThemeContext = createContext<ThemeContextType | null>(null);
